import { HSComponent } from "./component.js";
import * as Logger from "./logger.js";
import styles from "./view-picker.css";
import template from "./view-picker.html";
import { HSToolbarButton } from "./toolbar-button.js";
import { UserSession } from './session.js';
import { hasCapability } from './capabilities.js';
import openLinkImg from './img/open-link.svg';
import statsViewImg from './img/stats-view.svg';

class HSViewPicker extends HSComponent {
    constructor() {
        super();
    }

    onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);

        this.onEvent('hs-table-view', (opts, ev) => this.setSelected(opts));
        this.onEvent('hs-tiles-view', (opts, ev) => this.setSelected(opts));
        const userinfo = UserSession.get('userinfo');
        const canUseStatsView = hasCapability(userinfo, 'stats.view');
        if (canUseStatsView) {
            this.onEvent('hs-stats-view', (opts, ev) => this.setSelected(opts));
        } else {
            const statsViewButton = this.shadowRoot.querySelector('hs-toolbar-button[action="hs-stats-view"]');
            statsViewButton?.remove();
        }

        const providers = UserSession.get("providers");
        const user_providers = UserSession.get("user_providers");
        if (Array.isArray(providers) && providers.length === 1) {
            const tilesViewButton = this.shadowRoot.querySelector('hs-toolbar-button[action="hs-tiles-view"]');
            const tableViewButton = this.shadowRoot.querySelector('hs-toolbar-button[action="hs-table-view"]');
            tilesViewButton?.remove();
            if (tableViewButton) {
                this.setSelected({ button: tableViewButton });
            }
        }

        if (user_providers.some(x => !x.staffadmin)) {
            const container = this.shadowRoot.querySelector(".container");
            const linksViewButton = document.createElement("hs-toolbar-button");
            linksViewButton.classList.add("selectable");
            linksViewButton.setAttribute("icon", openLinkImg);
            linksViewButton.setAttribute("action", "hs-links-view");
            container.appendChild(linksViewButton);
            this.onEvent('hs-links-view', (opts, ev) => this.setSelected(opts));
        }
    }

    setSelected(opts) {
        const buttons = this.shadowRoot.querySelectorAll("hs-toolbar-button");
        buttons.forEach(button => {
            if (button != opts.button) {
                button.setSelected(false);
            }
        });
        opts.button?.setSelected(true);
    }

    setSelectedByView(viewName) {
        const actionMap = {
            'tiles': 'hs-tiles-view',
            'table': 'hs-table-view',
            'stats': 'hs-stats-view',
            'links': 'hs-links-view'
        };
        const action = actionMap[viewName];
        if (!action) {
            Logger.warn('setSelectedByView: unknown view', viewName);
            return;
        }
        const button = this.shadowRoot.querySelector(`hs-toolbar-button[action="${action}"]`);
        if (button) {
            this.setSelected({ button });
        }
    }
}
customElements.define("hs-view-picker", HSViewPicker);
